import styled from 'styled-components';

export const SideFloatingButtonWrapper = styled.button`
  min-width: 1rem;
  font-size: 1rem;
  padding: 1.5rem 1rem;
  position: fixed;
  cursor: pointer;
  top: 50%;
  z-index: 99;
  transform: rotate(-90deg);
  outline: none;
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props?.themeConfig?.buttonPrimary?.color};
  background-color: ${(props) => props?.themeConfig?.buttonPrimary?.backgroundColor};
  border-radius: ${(props) => props?.themeConfig?.buttonPrimary?.borderRadius};
  font-family: ${(props) => props?.themeConfig?.buttonPrimary?.fontFamily};
  font-weight: ${(props) => props?.themeConfig?.buttonPrimary?.fontWeight};
  ::after {
    color: ${(props) => props?.themeConfig?.buttonPrimary?.color};
    background-color: ${(props) =>
      props?.themeConfig?.buttonPrimary?.backgroundHoverColor};
  }
  & svg {
    fill: currentColor;
  }
  & svg path {
    fill: currentColor;
  }

  transform-origin: top right;
  white-space: nowrap;

  @media screen and (min-width: 768px) {
    &.btn_side_floating_cfe {
      right: ${(props) => (props?.styleConfig === 'right' ? '4.6%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '25.6px' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
    &.btn_side_floating_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '395px' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
    &.btn_side_floating_preview_desktop {
      right: ${(props) => (props?.styleConfig === 'right' ? '6.9%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
    &.btn_side_floating_preview_mobile {
      right: ${(props) => (props?.styleConfig === 'right' ? '41.4%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '4%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
  }
  @media screen and (min-width: 1441px) {
    &.btn_side_floating_cfe {
      right: ${(props) => (props?.styleConfig === 'right' ? '2.6%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '25.6px' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
    &.btn_side_floating_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '395px' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '2.2%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
  }
  @media screen and (max-width: 767px) {
    &.btn_side_floating_cfe {
      padding: 1rem;
      right: ${(props) => (props?.styleConfig === 'right' ? '11.8%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '0%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(0, -50%) scale(-1) `
          : `translate(0, -50%) `};
      transform: rotate(-90deg);
    }
    &.btn_side_floating_builder {
      right: ${(props) => (props?.styleConfig === 'right' ? '395px' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '7.5%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(-50%, -50%) scale(-1)`
          : `translate(-50%, -50%) `};
      transform: rotate(-90deg);
    }
  }
  @media screen and (max-width: 424px) {
    &.btn_side_floating_cfe {
      padding: 1rem;
      right: ${(props) => (props?.styleConfig === 'right' ? '12%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '0%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(0, -50%) scale(-1) `
          : `translate(0, -50%) `};
      transform: rotate(-90deg);
    }
  }
  @media screen and (max-width: 324px) {
    &.btn_side_floating_cfe {
      padding: 1rem;
      right: ${(props) => (props?.styleConfig === 'right' ? '15.7%' : 'unset')};
      left: ${(props) => (props?.styleConfig === 'left' ? '0%' : 'unset')};
      transform: ${(props) =>
        props?.styleConfig === 'right'
          ? `translate(0, -50%) scale(-1) `
          : `translate(0, -50%) `};
      transform: rotate(-90deg);
    }
  }
`;
